export { default as GDMLotRegisterForm } from './GDMLotRegisterForm';
export type {
  GDMLotRegisterFormComponent,
  GDMLotRegisterFormProps,
} from './GDMLotRegisterForm.type';
